'use client'

import { useEffect } from 'react'

// Shown when a page fails to render (for example a backend outage). Next sends
// it with a 500; ISR pages keep serving their last good copy instead.
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className='min-h-screen grid place-content-center px-4'>
      <div className='bg-white text-[#1D4749] grid gap-5 justify-items-center p-8 rounded-xl text-center max-w-md'>
        <h1 className='font-bold text-2xl'>This page couldn&apos;t load</h1>
        <p className='text-[#565151]'>Something went wrong on our side. Try again, or go back to the home page.</p>
        <div className='flex gap-3'>
          <button className='bg-[#1D4749] px-4 py-2 rounded-md text-white' onClick={() => reset()}>
            Try again
          </button>
          <a href='/' className='px-4 py-2 rounded-md border border-[#1D4749] text-[#1D4749]'>
            Home
          </a>
        </div>
      </div>
    </div>
  )
}
